import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

import {
    getAuth,
    fetchSignInMethodsForEmail,
    sendSignInLinkToEmail,
    isSignInWithEmailLink,
    signInWithEmailLink,
    updateProfile,
    getAdditionalUserInfo,
    
} from "firebase/auth";

import { firebaseApp } from "./config";
import { storeUsername } from './firestore';

const { REACT_APP_NODE_ENV, REACT_APP_DEVELOPMENT_URL, REACT_APP_PRODUCTION_URL } = process.env
const baseUrl = REACT_APP_NODE_ENV === 'development' ? REACT_APP_DEVELOPMENT_URL : REACT_APP_PRODUCTION_URL;

const baseActionCodeSettings = {
    linkDomain: 'SpitfaceBattles.com',
    handleCodeInApp: true,
    url: `${baseUrl}`
};

initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true
});

const auth = getAuth(firebaseApp);

export const sendEmailLink = async (email, username) => {
    try {
        const currentPath = window.location.pathname + window.location.search;

        const url = new URL('/verify', window.location.origin);

        if (username) {
            url.searchParams.set('username', username);
        }

        url.searchParams.set('return', currentPath);

        const actionCodeSettings = {
            ...baseActionCodeSettings,
            url: url.toString(),
        };
        
        await sendSignInLinkToEmail(auth, email, actionCodeSettings);
        window.localStorage.setItem('emailForSignIn', email);
    } catch (error) {
        throw new Error(error.message, { cause: { ...error.cause }});
    }
};

export const signInEmailLink = async () => {
    try {
        if (isSignInWithEmailLink(auth, window.location.href)) {
            let email = window.localStorage.getItem('emailForSignIn');
            
            if (!email) {
                email = window.prompt('Please confirm the email address you used to reserve your username.');
            }

            const params = new URLSearchParams(window.location.search);
            const displayName = params.get('username');

            const result = await signInWithEmailLink(auth, email, window.location.href)
            const user = result.user;

            if (getAdditionalUserInfo(result)?.isNewUser && displayName && !user.displayName) {
              await updateProfile(user, { displayName });
              await storeUsername(user.uid, displayName);
              await user.reload();
            }

            window.localStorage.setItem('emailForSignIn', email);

            return user;
        }
    } catch (error) {
        throw new Error(error.message, { cause: { ...error.cause }});
    }
};

export const updateUsername = async (username = 'testing') => {
  if (!auth.currentUser) {
    throw new Error('No authenticated user.');
  }

  if (!auth.currentUser?.displayName) {
    throw new Error('Username is already set.');
  }

  await updateProfile(auth.currentUser, { displayName: username });

  return auth.currentUser;
};

export const checkEmailAvailability = async (email, isSignIn = false) => {
    const auth = getAuth(firebaseApp);
    
    try {
        const signInMethods = await fetchSignInMethodsForEmail(auth, email);
        const doesExist = signInMethods.length > 0;
        return isSignIn ? doesExist : !doesExist;
    } catch (error) {
        throw new Error(error.message, { cause: { ...error.cause }});
    }
};

export const isLoggedIn = () => {
  return Boolean(auth?.currentUser);
};

export const isEmailVerified = () => {
  if (isLoggedIn() !== true) return false;
  return Boolean(auth?.currentUser?.emailVerified);
};

export const hasDisplayName = () => {
  if (isLoggedIn() !== true) return false;
  return Boolean(auth?.currentUser?.displayName);
};

export const getUserId = () => {
    if (isLoggedIn() !== true) return false;
    return auth?.currentUser?.uid;
};

export const getUserEmail = () => {
    if (isLoggedIn() !== true) return false;
    return auth?.currentUser?.email;
}

export default auth;